var map = {
	"./01_BLUEBERRY.png": 7719,
	"./01_suika_cherry.png": 7759,
	"./02_STRAWBERRY.png": 8518,
	"./02_suika_strawberry.png": 1229,
	"./03_TANGERINE.png": 9665,
	"./03_suika_grapes.png": 7136,
	"./04_TOMATO.png": 3618,
	"./04_suika_dekopon.png": 1108,
	"./05_AVOCADO.png": 1831,
	"./05_suika_orange.png": 1849,
	"./06_KOREANMELON.png": 4048,
	"./06_suika_apple.png": 9941,
	"./07_APPLE.png": 1558,
	"./07_suika_pear.png": 4509,
	"./08_PEACH.png": 9057,
	"./08_suika_peach.png": 7691,
	"./08_suika_savannah.png": 3435,
	"./09_COCONUT.png": 8538,
	"./09_suika_pineapple.png": 847,
	"./10_MELON.png": 6883,
	"./10_suika_melon.png": 1085,
	"./11_WATERMELON.png": 5010,
	"./11_suika_watermelon.png": 1735,
	"./12_GOLDWATERMELON.png": 4461,
	"./250/01_suika_cherry.png": 9118,
	"./250/02_suika_strawberry.png": 9841,
	"./250/03_suika_grapes.png": 9103,
	"./250/04_suika_dekopon.png": 4721,
	"./250/05_suika_orange.png": 2204,
	"./250/06_suika_apple.png": 7891,
	"./250/07_suika_pear.png": 3849,
	"./250/08_suika_peach.png": 5199,
	"./250/08_suika_savannah.png": 7881,
	"./250/09_suika_pineapple.png": 4425,
	"./250/10_suika_melon.png": 3259,
	"./250/11_suika_watermelon.png": 9656,
	"./400/01_suika_cherry.png": 90,
	"./400/02_suika_strawberry.png": 6500,
	"./400/03_suika_grapes.png": 2182,
	"./400/04_suika_dekopon.png": 9256,
	"./400/05_suika_orange.png": 1379,
	"./400/06_suika_apple.png": 6387,
	"./400/07_suika_pear.png": 7557,
	"./400/08_suika_peach.png": 1550,
	"./400/09_suika_pineapple.png": 6547,
	"./400/10_suika_melon.png": 491,
	"./400/11_suika_watermelon.png": 6165,
	"./BOMB.png": 299,
	"./bubble.png": 155,
	"./original/01_suika_cherry.png": 4347,
	"./original/02_suika_strawberry.png": 8604,
	"./original/03_suika_grapes.png": 312,
	"./original/04_suika_dekopon.png": 4398,
	"./original/05_suika_orange.png": 1446,
	"./original/06_suika_apple.png": 8523,
	"./original/07_suika_pear.png": 5620,
	"./original/08_suika_peach.png": 4486,
	"./original/08_suika_savannah.png": 9128,
	"./original/09_suika_pineapple.png": 2128,
	"./original/10_suika_melon.png": 1169,
	"./original/11_suika_watermelon.png": 8049,
	"./original/12_GOLDWATERMELON.png": 8531,
	"./original/New Project (1).png": 4117,
	"./resized.png": 2451,
	"./suika_wheel.png": 1889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3395;